module.exports = __webpack_public_path__ + "img/stage_jp.48d68ac.jpg";